/* eslint-disable jsx-a11y/anchor-is-valid */

import { VscLocation, VscMail } from 'react-icons/vsc';
import { AiOutlinePhone } from 'react-icons/ai';

//#region component definition
export const BottomBar: React.FC = () => {
  return (
    <section className="bottom-bar">
      <p className="bottom-bar-contact-info">
        054-478-9338
        <i className="bottom-bar-icon">
          <AiOutlinePhone size="25" />
        </i>
      </p>
      {/* <p className="bottom-bar-contact-info">
        מרכז לבריאות הנפש על יד שירות בתי הסהר
        <span className="bottom-bar-icon">
          <VscLocation size="25" />
        </span>
      </p> */}
      <p className="bottom-bar-contact-info">
        ruthduek@gmail.com
        <span className="bottom-bar-icon">
          <VscMail size="25" />
        </span>
      </p>
    </section>
  );
}
//#endregion